module.exports = __webpack_public_path__ + "3cd6e122c478bd3e2b5226281e1ecd14.MP3";